import { CONSENT_TYPES } from '../contexts/ConsentContext';
import { ANALYTICS_CONFIG } from '../config/analytics';

export const GA_MEASUREMENT_ID = ANALYTICS_CONFIG.GA_MEASUREMENT_ID;

// Initialize Google Analytics
export const initGA = () => {
  // Load gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  
  // Initialize with consent mode
  gtag('consent', 'default', {
    'analytics_storage': 'denied',
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'functionality_storage': 'denied',
    'personalization_storage': 'denied',
    'security_storage': 'granted'
  });

  gtag('config', GA_MEASUREMENT_ID, {
    anonymize_ip: ANALYTICS_CONFIG.ANONYMIZE_IP,
    allow_google_signals: ANALYTICS_CONFIG.ALLOW_GOOGLE_SIGNALS,
    allow_ad_personalization_signals: ANALYTICS_CONFIG.ALLOW_AD_PERSONALIZATION,
    cookie_domain: ANALYTICS_CONFIG.COOKIE_DOMAIN,
    cookie_expires: ANALYTICS_CONFIG.COOKIE_EXPIRES * 24 * 60 * 60, // Convert days to seconds
    debug_mode: ANALYTICS_CONFIG.DEBUG_MODE
  });
};

// Update consent based on user preferences
export const updateGAConsent = (consent) => {
  if (!window.gtag) return;

  const consentUpdate = {
    'analytics_storage': consent[CONSENT_TYPES.ANALYTICS] ? 'granted' : 'denied',
    'ad_storage': consent[CONSENT_TYPES.MARKETING] ? 'granted' : 'denied',
    'ad_user_data': consent[CONSENT_TYPES.MARKETING] ? 'granted' : 'denied',
    'ad_personalization': consent[CONSENT_TYPES.MARKETING] ? 'granted' : 'denied',
    'functionality_storage': consent[CONSENT_TYPES.PREFERENCES] ? 'granted' : 'denied',
    'personalization_storage': consent[CONSENT_TYPES.PREFERENCES] ? 'granted' : 'denied',
    'security_storage': 'granted' // Always granted for necessary functionality
  };

  window.gtag('consent', 'update', consentUpdate);
};

// Track page views
export const trackPageView = (path, title) => {
  if (!window.gtag) return;
  
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
    page_title: title,
  });
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (!window.gtag) return;
  
  window.gtag('event', eventName, {
    event_category: parameters.category || 'General',
    event_label: parameters.label,
    value: parameters.value,
    ...parameters
  });
};

// Predefined event tracking functions
export const trackButtonClick = (buttonName, section = 'Unknown') => {
  trackEvent('button_click', {
    category: 'User Interaction',
    label: buttonName,
    section: section
  });
};

export const trackFormSubmission = (formName) => {
  trackEvent('form_submit', {
    category: 'Form',
    label: formName
  });
};

export const trackScrollDepth = (depth) => {
  trackEvent('scroll_depth', {
    category: 'Engagement',
    label: `${depth}%`,
    value: depth
  });
};

export const trackFileDownload = (fileName, fileType) => {
  trackEvent('file_download', {
    category: 'Download',
    label: fileName,
    file_type: fileType
  });
};

export const trackOutboundLink = (url, linkText) => {
  trackEvent('outbound_link', {
    category: 'External Link',
    label: linkText,
    url: url
  });
};
